import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { BodyText } from '@paypalcorp/pp-react';
import { fireDetailsPageComponentFailureFpti } from '../../../lib/helpers';
const ActivationFragment = loadable(() =>
  import(/* webpackChunkName: "ActivationFragment" */ './ActivationFragment')
);

const DetailsSetup = props => {
  const { componentContent, location, fptiImpression } = props;
  const { title, subtitle } = componentContent;

  if (!title || !subtitle) {
    fireDetailsPageComponentFailureFpti({
      data: { title, subtitle },
      componentName: 'DetailsSetup',
      fptiImpression
    });
    return null;
  }

  return (
    <section id="details-setup">
      <div className="details-setup-container">
        <div className="details-setup-title">
          <h3>{title}</h3>
          <BodyText >{subtitle}</BodyText>
        </div>
        <ActivationFragment location={location} />
      </div>
    </section>
  );
};

DetailsSetup.propTypes = {
  componentContent: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string
  }),
  location: PropTypes.string,
  fptiImpression: PropTypes.func.isRequired
};

export default DetailsSetup;
